export default function mtaReducer(
    state: any = {
        submit: null,
        bound: null,
        policy: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        summary: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        submitLoading: false,
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get policy info
         */
        case 'GET_POLICY_MTA_PENDING': {
            return {
                ...state,
                policy: {
                    ...state.policy,
                    loading: true,
                },
            }
        }

        case 'GET_POLICY_MTA_REJECTED': {
            return {
                ...state,
                policy: {
                    ...state.policy,
                    loading: false,
                    error: action.payload,
                },
            }
        }

        case 'GET_POLICY_MTA_FULFILLED': {
            return {
                ...state, policy: {
                    ...state.policy,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload.policy,
                },
            }
        }

        /**
         *     Get Summary
         */
        case 'GET_MTA_PREVIEW_PENDING': {
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: true,
                },
            }
        }

        case 'GET_MTA_PREVIEW_REJECTED': {
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false,
                    error: action.payload,
                },
            }
        }

        case 'GET_MTA_PREVIEW_FULFILLED': {
            return {
                ...state, summary: {
                    ...state.summary,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload.mta,
                },
            }
        }

        /**
         *  Add MTA
         */
        case 'ADD_MTA_PENDING': {
            return {
                ...state,
                submitLoading: true,
            }
        }
        case 'ADD_MTA_FULFILLED': {
            return {
                ...state,
                submit: action.payload,
                submitLoading: false,
            }
        }
        case 'ADD_MTA_REJECTED': {
            return {
                ...state,
                submitLoading: false,
            }
        }

        /**
         *  Add MTA
         */
        case 'BIND_MTA_FULFILLED': {
            return {
                ...state,
                bound: true,
            }
        }

        /**
         *  Reset MTA
         */
        case 'RESET_MTA': {
            return {
                submit: null,
                bound: null,
                policy: {
                    loading: false,
                    done: false,
                    error: null,
                    response: {},
                },
                summary: {
                    loading: false,
                    done: false,
                    error: null,
                    response: {},
                },
            }
        }

        /**
         * Remove policy submit
         */

        case 'REMOVE_POLICY_SUBMIT': {
            return {
                ...state,
                submit: null,
            }
        }
        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/policies/mta.ts